// Default options
// ---------------

var defaultOptions = {
  forceUpdate: false,
  setInvalidAttrs: false,
  selector: 'name',
  labelFormatter: 'sentenceCase',
  valid: Function.prototype,
  invalid: Function.prototype
};


export {defaultOptions};